<template>
  <scroll-view :scroll="true" class="contactCatalog-index">
    <img
      src="../../../assets/img/logo.jpg"
      style="width: 100%;margin-bottom: 3rem;"
      @click="moreTap('/contactCatalog/progeny/signIn')"
      v-if="loginInfo.token == 0 || userInfo.is_pay == 0"
    />
    <div
      v-if="userInfo != null && loginInfo.token != 0 && userInfo.is_pay != 0"
      class="contactCatalog-userInfo"
      @click="refBomb(true)"
    >
      <img :src="userInfo.cover_image_text" class="contactCatalog-userInfo-img" />
      <div class="contactCatalog-userInfo-name">{{userInfo.company_name}}</div>
      <div class="contactCatalog-userInfo-text">会员等级:{{userInfo.level_text}}</div>
      <div class="contactCatalog-userInfo-text">账号到期:{{userInfo.endtime_text}}</div>
      <div
        class="contactCatalog-userInfo-text"
        style="margin-bottom: 0;"
        v-if="userInfo.level_id > 1"
      >会员期限:{{userInfo.mendtime_text}}</div>
    </div>
    <div
      v-if="userInfo != null && loginInfo.token != 0 && userInfo.is_pay != 0"
      style="margin-bottom: 3rem;"
    >
      <div class="contactCatalog-flex" @click="moreTap('/contactCatalog/progeny/operation')">
        <div>图库管理</div>
        <div>点击</div>
      </div>
      <div class="contactCatalog-flex">
        <div>账号续费</div>
        <div @click="moreTap('/renew')">点击</div>
      </div>
      <div class="contactCatalog-flex" v-if="userInfo.level_id > 1">
        <div>会员续费</div>
        <div @click="moreTap('/renewhui')">点击</div>
      </div>
    </div>
    <div v-if="userInfo != null">
      <div class="contactCatalog-flex">
        <div>
          <img src="../../../assets/img/contactCatalogimages/1.png" class="contactCatalog-img" />
          <span style="margin-left: 0.2rem;color: #000000;">手机号</span>
        </div>
        <div id="id1" @click="phone(userInfo.mobile)">{{userInfo.mobile}}</div>
      </div>
      <div class="contactCatalog-flex">
        <div>
          <img src="../../../assets/img/contactCatalogimages/2.png" class="contactCatalog-img" />
          <span style="margin-left: 0.2rem;color: #000000;">微信号</span>
        </div>
        <div id="id2" @click="copy('id2')">{{userInfo.weixin}}</div>
      </div>
      <div class="contactCatalog-flex">
        <div>
          <img src="../../../assets/img/contactCatalogimages/3.png" class="contactCatalog-img" />
          <span style="margin-left: 0.2rem;color: #000000;">电子邮箱</span>
        </div>
        <div id="id3" @click="copy('id3')">{{userInfo.email}}</div>
      </div>
      <div class="contactCatalog-flex">
        <div>
          <img src="../../../assets/img/contactCatalogimages/4.png" class="contactCatalog-img" />
          <span style="margin-left: 0.2rem;color: #000000;">座机</span>
        </div>
        <div id="id4" @click="copy('id4')">{{userInfo.telephone}}</div>
      </div>
      <div class="contactCatalog-flex">
        <div>
          <img src="../../../assets/img/contactCatalogimages/5.png" class="contactCatalog-img" />
          <span style="margin-left: 0.2rem;color: #000000;">地址</span>
        </div>
        <div id="id5" @click="copy('id5')">{{userInfo.address}}</div>
      </div>
      <div class="contactCatalog-flex">
        <div>
          <img src="../../../assets/img/contactCatalogimages/1.png" class="contactCatalog-img" />
          <span style="margin-left: 0.2rem;color: #000000;">清除缓存</span>
        </div>
        <div id="id6" @click="eliminateTap()">清除</div>
      </div>
    </div>
    <input id="copy" style="opacity: 0;" disabled="disabled" />
    <bomb ref="bomb" height="100%" width="70%" angle="left">
      <div class="contactCatalog-bomb">
        <div class="contactCatalog-bomb-userInfo" v-if="userInfo != null">
          <img :src="userInfo.cover_image_text" class="contactCatalog-bomb-img" />
          <div class="contactCatalog-bomb-userInfo-flex">
            <div style="font-size: 1.3rem;">{{userInfo.level_text}}</div>
            <div class="contactCatalog-bomb-progress">
              <div :style="{width: userInfo.pic_size.per + '%'}"></div>
            </div>
            <div>{{userInfo.pic_size.album_size}}m/{{userInfo.pic_size.level_size}}m</div>
          </div>
        </div>

        <div style="background-color: #1a1e21;" v-if="userInfo != null">
          <div class="contactCatalog-bomb-item" @click="moreTap('/upgrade')">
            <div>账号升级</div>
            <span class="iconfont icon-046"></span>
          </div>
          <div
            class="contactCatalog-bomb-item"
            @click="moreTap('/contactCatalog/progeny/operation')"
          >
            <div>
              图库管理
              <span style="margin-left: 0.5rem;color: #FF0000;">{{userInfo.pic_count}}(张)</span>
            </div>
            <span class="iconfont icon-046"></span>
          </div>
          <div
            class="contactCatalog-bomb-item"
            @click="moreTap('/contactCatalog/progeny/information')"
          >
            <div>账号信息</div>
            <span class="iconfont icon-046"></span>
          </div>
          <div
            class="contactCatalog-bomb-item"
            @click="homeCatalog('/homeCatalog?alias=' + loginInfo.album_alias)"
          >
            <div>我的图库</div>
            <span class="iconfont icon-046"></span>
          </div>
        </div>

        <div style="background-color: #1a1e21;margin-top: 3rem;">
          <div class="contactCatalog-bomb-item" @click="signOut()">
            <div>退出登录</div>
            <span class="iconfont icon-046"></span>
          </div>
        </div>

        <div class="contactCatalog-bomb-item-text" @click="refBomb(false)">关闭</div>
      </div>
    </bomb>
    <div class="bottomText">版本:1.0.7</div>
  </scroll-view>
</template>

<script>
import {
  Albumgetinfo,
  Albumlevelgetinfo,
  AlbumgetBaseInfo,
} from '@/request/api.js'

export default {
  data () {
    return {

    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },
    loginInfo () {
      return this.$store.state.loginInfo
    },
  },
  created () {
    this.created_load()
    typeof WeixinJSBridge !== 'undefined' && WeixinJSBridge.call('hideOptionMenu')
  },
  methods: {
    async created_load () {
      let newRes
      try {
        const res = await Albumlevelgetinfo('')
        if (this.loginInfo.token == 0) {
          newRes = await AlbumgetBaseInfo('')
          newRes = newRes.data
        } else {
          newRes = await Albumgetinfo('')
          newRes = newRes.data
        }
        newRes.used_space = res.data.used_space
        newRes.pic_space = res.data.pic_space
        this.$api.commit('userInfo', newRes)
      } catch (e) {
        // TODO handle the exception
      }
    },
    phone (item) {
      window.location.href = `tel://${item}`
    },
    copy (item) {
      this.$api.Message('提示', '复制成功').then((res) => {
        console.log(res)
      })
      const copyText = document.getElementById(item)
      const queIdInput = document.getElementById('copy')
      queIdInput.value = copyText.innerText
      queIdInput.select()
      document.execCommand('Copy')
    },
    eliminateTap () {
      const _self = this
      this.$api.Message('提示', '是否清空浏览器的缓存?').then((res) => {
        if (res) {
          _self.$api.showload('处理中')
          const date = new Date()
          date.setTime(date.getTime() - 10000)
          const cookieList = document.cookie.replace(/['" ]/g, '').split(';')
          cookieList.map((item) => {
            document.cookie = `${item.split('=')[0]}=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
          })
          localStorage.clear()
          setTimeout(() => {
            _self.$api.hidload()
            _self.$api.Message('提示', '清除成功')
          }, 1000)
        }
      })
    },
    moreTap (url) {
      console.log(url)
      this.$router.push({
        path: url,
      })
    },
    homeCatalog (url) {
      const { loginInfo } = this
      loginInfo.album_alias = this.userInfo.album_alias
      this.$api.commit('loginInfo', loginInfo)

      const cookieDate = new Date()
      cookieDate.setTime(cookieDate.getTime() + 60 * 1000 * 60 * 9) // 过期时间 2分钟
      document.cookie = `album_alias=${loginInfo.album_alias}; expires=${cookieDate.toGMTString()}`
      this.$router.push({
        path: url,
      })
    },
    refBomb (close) {
      this.$refs.bomb.share(close)
    },
    signOut () {
      const _slef = this
      this.$api.Message('提示', '是否退出该账号').then((data) => {
        if (data) {
          _slef.$api.showload('退出中...')
          _slef.refBomb(false)
          setTimeout(() => {
            _slef.$api.hidload()
            _slef.$api.commit('userInfo', null)// 清除用户信息
            const { loginInfo } = _slef.$store.state
            loginInfo.token = 0// 清除用户登录状态
            _slef.$api.commit('loginInfo', loginInfo)
            const cookieDate = new Date()// 清除历史记录
            cookieDate.setTime(cookieDate.getTime() + 60 * 1000 * 60 * 9)// 过期时间 2分钟
            document.cookie = `token=${loginInfo.token}; expires=${cookieDate.toGMTString()}`

            _slef.created_load()
          }, 500)
        }
      })
    },
  },
};
</script>

<style lang="less">
.contactCatalog-index {
  color: #2590c8;
  background-color: #f4f4f4;

  .contactCatalog-flex-text {
    width: 100%;
    color: #999;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    margin-top: 10px;
  }
  .contactCatalog-flex {
    width: 94%;
    padding: 3%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    flex-wrap: nowrap;
    font-size: 1.2rem;
    border-bottom: 1px solid #f4f4f4;
  }

  .contactCatalog-flex > div:nth-child(1) {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }
  .contactCatalog-flex > div:nth-child(2) {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-left: 1rem;
  }

  .contactCatalog-img {
    width: 2.5rem;
    height: 2.5rem;
  }

  .contactCatalog-userInfo {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #000000;
    padding: 3rem 0;
    margin-bottom: 3rem;
  }

  .contactCatalog-userInfo-img {
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    margin-bottom: 0.5rem;
  }

  .contactCatalog-userInfo-name {
    color: #ffffff;
    margin-bottom: 0.5rem;
    font-size: 2rem;
  }

  .contactCatalog-userInfo-text {
    margin-bottom: 0.5rem;
    color: #999;
  }

  .contactCatalog-bomb {
    width: 100%;
    height: 100%;
    background-color: #202427;
    display: flex;
    flex-direction: column;
  }

  .contactCatalog-bomb-item {
    background-color: #1a1e21;
    font-size: 1.3rem;
    width: 88%;
    padding: 5%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 7%;
    color: #ffffff;
    padding-left: 0;
  }

  .contactCatalog-bomb-userInfo {
    width: 90%;
    display: flex;
    flex-wrap: nowrap;
    padding: 10% 5%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .contactCatalog-bomb-img {
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    margin-right: 1rem;
  }

  .contactCatalog-bomb-userInfo-flex {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .contactCatalog-bomb-userInfo-flex > div {
    color: #ffffff;
    margin-bottom: 0.5rem;
  }

  .contactCatalog-bomb-progress {
    border-radius: 0.3rem;
    height: 0.3rem;
    width: 100%;
    transition: 0.5s;
    overflow: hidden;
    background-color: #999;
  }
  .contactCatalog-bomb-progress > div {
    height: 100%;
    background-color: #189f92;
    transition: 0.5s;
  }

  .contactCatalog-bomb-item-text {
    font-size: 1.3rem;
    width: 90%;
    padding: 5%;
    margin-top: 3rem;
  }
  .bottomText {
    width: 100%;
    text-align: center;
    margin: 7px 0;
    color: #999;
    font-size: 14px;
  }
}
</style>
